import React from 'react'
import { Media } from '@/payload-types'
import classNames from 'classnames'
import Link from 'next/link'
import { CMSImage } from '@/ui/atoms/CMSImage'
import { Avatar } from '@/ui/atoms/Avatar'

type VendorProps = {
  name: string
  logo?: Media | string
  size?: 'extraMini' | 'mini' | 'big'
  type?: 'default' | 'profile'
  href?: string
  className?: string
}

export function Vendor({
  name,
  logo,
  size = 'mini',
  type = 'default',
  href,
  className,
}: VendorProps) {
  const isProfile = type === 'profile'
  const isBig = size === 'big'
  const isExtraMini = size === 'extraMini'

  const logoSize = {
    width: isProfile ? 64 : isBig ? 58 : isExtraMini ? 63 : 40,
    height: isProfile ? 64 : isBig ? 39 : isExtraMini ? 42 : 26.67,
  }

  const renderLogo = () => {
    if (isProfile) {
      return (
        <Avatar
          userImage={logo}
          size="big"
          variant="rounded"
          className="border border-border-subtle"
        />
      )
    }

    return logo ? (
      <div
        className={classNames(
          'rounded overflow-hidden bg-white border-border-subtle border-solid border-[1px]',
          isProfile
            ? 'w-16 h-16'
            : isBig
              ? 'w-[72px] h-[48px]'
              : isExtraMini
                ? 'h-[42px] w-auto'
                : 'w-[56px] h-[37px]',
        )}
      >
        {logo && (
          <CMSImage
            resource={logo}
            width={logoSize.width}
            height={logoSize.height}
            className="w-full h-full object-contain"
          />
        )}
      </div>
    ) : null
  }

  const content = (
    <>
      {renderLogo()}
      <div className="flex-1">
        <span
          className={
            href
              ? 'underline underline-offset-2 text-body-XS-medium text-text-accent group-hover:decoration-2'
              : 'text-body-XS-regular text-text-base'
          }
        >
          {name}
        </span>
      </div>
    </>
  )

  if (href) {
    return (
      <Link href={href} className={classNames('group flex items-center', isExtraMini ? 'gap-2' : 'gap-3', className)}>
        {content}
      </Link>
    )
  }

  return <div className={classNames('flex items-center', isExtraMini ? 'gap-2' : 'gap-3', className)}>{content}</div>
}
